var badgeReset = '_5wtle30';

export { badgeReset };
//# sourceMappingURL=badge-reset.css.js.map
